import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const NavbarComponent = ({ onNavigateToLogin, hasMessages = true }) => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [navExpanded, setNavExpanded] = useState(false);
  const [activeLink, setActiveLink] = useState('#home');

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleNavClick = (link) => {
    setActiveLink(link);
    if (windowWidth <= 991) {
      setNavExpanded(false);
    }
  };

  return (
    <div className="hero-background" id="home">
      {/* Desktop Navbar (hidden on mobile) */}
      <Navbar expand="lg" className={`landing-navbar ${scrolled ? 'mt-0' : windowWidth > 991 ? 'mt-0' : 'mt-0'} ${!hasMessages ? 'no-messages' : ''}`} expanded={navExpanded} onToggle={setNavExpanded}>
        <Container className="navbar-container">
          <Navbar.Brand href="#" className="navbar-brand">
            <img src={process.env.PUBLIC_URL + `${!hasMessages ? '/blue_maia_navbar.svg' : '/maia_navbar.svg'}`} alt="maia Logo" className="maia-logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" className='navbar-dark' />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="main-nav me-auto">
              <Nav.Link 
                href="#how"
                active={false} 
                className={activeLink === '#why' ? 'xactive' : ''}
                onClick={() => handleNavClick('#why')}
              >How MAIA Works?</Nav.Link>
              <Nav.Link 
                href="#aimodels"
                active={false} 
                className={activeLink === '#what' ? 'xactive' : ''}
                onClick={() => handleNavClick('#what')}
              >AI Models</Nav.Link>
              <Nav.Link 
                href="#globalimpact" 
                active={false} 
                className={activeLink === '#what' ? 'xactive' : ''}
                onClick={() => handleNavClick('#what')}
              >Global Impact</Nav.Link>
              <Nav.Link 
                href="/about" 
                active={false} 
                className={activeLink === '/about' ? 'xactive' : ''}
                onClick={() => {
                  navigate('/about');
                  if (windowWidth <= 991) setNavExpanded(false);
                }}
              >About</Nav.Link>
              <Nav.Link 
                href="#faq" 
                active={false} 
                className={activeLink === '#products' ? 'xactive' : ''}
                onClick={() => handleNavClick('#products')}
              >FAQ</Nav.Link>
              <Nav.Link 
                href="mailto:hello@ask-maia.com" 
                active={false} 
                className={activeLink === 'mailto:hello@ask-maia.com' ? 'xactive' : ''}
              >Contact</Nav.Link>
            </Nav>
            <div className="nav-buttons">
              <Button className="login-btn p-3 px-5" onClick={() => { onNavigateToLogin(); if (windowWidth <= 991) setNavExpanded(false); }}>Login</Button>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default NavbarComponent;